import type { CompassModalProps } from "@circle-react/components/SettingsApp/CompassCompat/modalHelpers";
import { PROFILE_PAGES } from "@circle-react/helpers/memberHelper";
import { Modal } from "@circleco/compass/components/Modal";

import { t } from "@/i18n-js/instance";
import { useAgentProfileInfo } from "@/react/hooks/agent_profile/useAgentProfileInfo";

import { AgentProfile } from "./AgentProfile";

const pageParams = {
  page_name: PROFILE_PAGES.PROFILE_VIEW,
};

interface AgentProfileModalComponentProps extends CompassModalProps {
  agentId: number;
  // not used, kept for compatibility with UIKit component
  params?: {
    shouldOpenInNewTab?: boolean;
  };
}

export const AgentProfileModalComponent = ({
  agentId,
  open,
  onOpenChange,
}: AgentProfileModalComponentProps) => {
  const {
    getAgentProfileInfoQuery: { data: agent, isInitialLoading: isLoading },
  } = useAgentProfileInfo({
    agentId,
    params: pageParams,
  });

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="xl">
      <Modal.Content>
        <Modal.Header title={t("profile")} showCloseButton />
        <Modal.Body customLayout>
          <div className="min-h-0 flex-1 grid-cols-12 md:grid md:grid-flow-row-dense md:grid-rows-1">
            <AgentProfile
              agent={agent}
              isLoading={isLoading}
              onClose={() => onOpenChange(false)}
            />
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
